<script setup lang="ts">
import { useAchievementsStore } from '../stores/achievements'

const ach = useAchievementsStore()
</script>

<template>
  <Transition name="toast">
    <div v-if="ach.newlyUnlocked" class="ach-toast" @click="ach.dismissNotification()">
      <span class="ach-emoji">{{ ach.newlyUnlocked.emoji }}</span>
      <div class="ach-text">
        <strong>成就解锁!</strong>
        <span>{{ ach.newlyUnlocked.title }}</span>
      </div>
    </div>
  </Transition>
</template>

<style scoped>
.ach-toast {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1100;
  background: linear-gradient(135deg, var(--ra-neon-pink), var(--ra-neon-purple));
  color: #fff;
  padding: 12px 20px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 14px;
  box-shadow: 0 8px 24px rgba(255, 46, 136, 0.5);
  animation: pop 0.3s ease-out;
  cursor: pointer;
}
.ach-emoji { font-size: 32px; }
.ach-text { display: flex; flex-direction: column; gap: 2px; }
.ach-text strong { font-family: var(--ra-font-pixel); font-size: 10px; }
.ach-text span { font-family: var(--ra-font-display); font-size: 16px; }

@keyframes pop {
  0% { transform: translate(-50%, -30px); opacity: 0; }
  100% { transform: translate(-50%, 0); opacity: 1; }
}
.toast-enter-active, .toast-leave-active { transition: all 0.3s; }
.toast-enter-from, .toast-leave-to { opacity: 0; transform: translate(-50%, -20px); }
</style>
